import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { of } from 'rxjs';
import { ColumnDefinition } from '../fpx-ro-grid/fpx-ro-grid.component';
import { SearchType } from '../../models/criteria.model';

@Component({
  selector: 'app-search-sort-ro-gird',
  templateUrl: './search-sort-ro-gird.component.html',
  styleUrls: ['./search-sort-ro-gird.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchSortRoGirdComponent),
      multi: true,
    },
  ],
})
export class SearchSortRoGirdComponent implements OnInit, ControlValueAccessor {
  @Input() col!: ColumnDefinition;
  @Input() formControlName!: string;
  form!: FormGroup;

  sortIcon: 'south' | 'north' = 'south';

  stringSelectableList$ = of([
    {
      id: 'Contains',
      text: 'Contains',
    },
    {
      id: 'equals',
      text: 'Equals',
    },
    {
      id: 'notEqual',
      text: 'Not Equal',
    },
    {
      id: 'startsWith',
      text: 'Starts With',
    },
    {
      id: 'endsWith',
      text: 'Ends With',
    },
    {
      id: 'isNull',
      text: 'Is Null',
    },
    {
      id: 'isNotNull',
      text: 'Is NotNull',
    },
  ]);

  numberSelectableList$ = of([
    {
      id: 'Contains',
      text: 'Contains',
    },
    {
      id: 'equals',
      text: 'Equals',
    },
    {
      id: 'notEqual',
      text: 'Not Equal',
    },
    {
      id: 'startsWith',
      text: 'Starts With',
    },
    {
      id: 'endsWith',
      text: 'Ends With',
    },
    {
      id: 'greaterThan',
      text: 'Greater Than',
    },
    {
      id: 'lessThan',
      text: 'Less Than',
    },
    {
      id: 'greaterThanEquals',
      text: 'Greater Than Equals',
    },
    {
      id: 'lessThanEquals',
      text: 'Less Than Equals',
    },
    {
      id: 'inRange',
      text: 'In Range',
    },
    {
      id: 'isNull',
      text: 'Is Null',
    },
    {
      id: 'isNotNull',
      text: 'Is NotNull',
    },
  ]);

  dateSelectableList$ = of([
    {
      id: 'equals',
      text: 'Equals',
    },
    {
      id: 'notEqual',
      text: 'Not Equal',
    },
    {
      id: 'greaterThan',
      text: 'Greater Than',
    },
    {
      id: 'lessThan',
      text: 'Less Than',
    },
    {
      id: 'greaterThanEquals',
      text: 'Greater Than Equals',
    },
    {
      id: 'lessThanEquals',
      text: 'Less Than Equals',
    },
    {
      id: 'inRange',
      text: 'In Range',
    },
    {
      id: 'isNull',
      text: 'Is Null',
    },
    {
      id: 'isNotNull',
      text: 'Is NotNull',
    },
  ]);

  timastampSelectableList$ = of([
    {
      id: 'equals',
      text: 'Equals',
    },
    {
      id: 'notEqual',
      text: 'Not Equal',
    },
    {
      id: 'greaterThan',
      text: 'Greater Than',
    },
    {
      id: 'lessThan',
      text: 'Less Than',
    },
    {
      id: 'greaterThanEquals',
      text: 'Greater Than Equals',
    },
    {
      id: 'lessThanEquals',
      text: 'Less Than Equals',
    },
    {
      id: 'inRange',
      text: 'In Range',
    },
    {
      id: 'isNull',
      text: 'Is Null',
    },
    {
      id: 'isNotNull',
      text: 'Is NotNull',
    },
  ]);

  constructor(private _formBuilder: FormBuilder) {}
  writeValue(obj: any): void {
    if (obj) {
      this.form.patchValue(obj);
    } else {
      this.form.reset();
    }
  }
  onChange: any = () => {};

  onTouched: () => void = () => {};
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit(): void {
    if (this.col.action === 'sort') {
      this.form = new FormGroup({
        sort: new FormControl<'asc' | 'desc'>('asc', { updateOn: 'change' }),
      });
    } else if (this.col.action === 'search') {
      this.form = new FormGroup({
        condition: new FormControl<SearchType | ''>('', { updateOn: 'change' }),
        filter: new FormControl<string>('', { updateOn: 'blur' }),
      });
    } else if (this.col.action === 'sort&search') {
      this.form = new FormGroup({
        condition: new FormControl<SearchType | ''>('', { updateOn: 'change' }),
        filter: new FormControl<string>('', { updateOn: 'blur' }),
        sort: new FormControl<'asc' | 'desc'>('asc', { updateOn: 'change' }),
      });
    }
    this.form.valueChanges.subscribe({
      next: (res) => {
        this.onChange(res);
        this.onTouched();
      },
    });
  }

  onSortClick(event: MouseEvent, icon: 'south' | 'north') {
    event.preventDefault();
    event.stopPropagation();
    if (icon === 'south') {
      this.form.get('sort')?.setValue('desc');
      this.sortIcon = 'north';
    } else if (icon === 'north') {
      this.form.get('sort')?.setValue('asc');
      this.sortIcon = 'south';
    }
  }
}
